import { useState } from 'react'
import { Span } from './read-more.styled'
import RichContent from '../../particles/rich-content'

const ReadMore = ({ children, words, readMoreLabel, showLessLabel, isHtml }) => {
	const text = children
	const [isReadMore, setIsReadMore] = useState(true)
	const toggleReadMore = () => {
		setIsReadMore(!isReadMore)
	}

	return text.length > words ? (
		<span className="read-more">
			{isHtml ? (
				isReadMore ? (
					<RichContent content={text.slice(0, words) + '...'} />
				) : (
					<RichContent content={text} />
				)
			) : isReadMore ? (
				text.slice(0, words)
			) : (
				text
			)}
			<Span onClick={toggleReadMore} className="read-or-hide">
				{isReadMore ? readMoreLabel : showLessLabel}
			</Span>
		</span>
	) : isHtml ? (
		<RichContent content={text} />
	) : (
		text
	)
}

ReadMore.defaultProps = {
	words: 60,
	readMoreLabel: 'read_more',
	showLessLabel: 'show_less',
	isHtml: false,
}

export default ReadMore
